import http from '../api/http'

export default {
  all: () => { return http.get('/payment-methods/all') }
}



// WEBPACK FOOTER //
// ./src/services/payment-methods.js